import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import RouteMapDetail from '../components/route_maps/RouteMapDetail'

const mapStateToProps = state => {
  const { themeName } = state.themeReducer
  const { appVersion } = state.appVersionReducer

  return {
    themeName,
    appVersion,
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RouteMapDetail)
